import { render, staticRenderFns } from "./V2BrandDetail.vue?vue&type=template&id=cae24b82&scoped=true&"
import script from "./V2BrandDetail.vue?vue&type=script&lang=js&"
export * from "./V2BrandDetail.vue?vue&type=script&lang=js&"
import style0 from "./V2BrandDetail.vue?vue&type=style&index=0&id=cae24b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae24b82",
  null
  
)

export default component.exports